// JS file for SupplierItem
